import plPL from 'antd/es/locale/pl_PL';
import enUS from 'antd/es/locale/en_US';

import i18n from '../settings/i18n/i18n';
import { Language } from '../settings/i18n/language';

export const getAntdLocalesLanguage = () => {
  switch (i18n.resolvedLanguage) {
    case Language.EN:
      return enUS;

    case Language.PL:
      return plPL;

    default:
      return plPL; // only PL now
  }
};
